import React from "react";
import { H5 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
var StepFive = function () { return (React.createElement(React.Fragment, null,
    React.createElement(H5, { tiny: true, bold: true },
        React.createElement(FormattedMessage, { id: "platform.admin.tour.stepFive.header" })),
    React.createElement(Para, null,
        React.createElement(FormattedMessage, { id: "platform.admin.tour.stepFive.content" })))); };
export default StepFive;
